<template>
  <div>
    <span>
      (
      <b-link v-if="!topUpClicked" v-on:click="onTopUpClick" class="btn-link">
        Top Up Wallet
      </b-link>
      <b-link
        v-if="topUpClicked"
        v-on:click="onTopUpCancelClick"
        class="btn-link"
      >
        Close Top Up
      </b-link>
      )
    </span>
    <billing-widget
      v-if="showBillingWidget"
      :wallet="wallet"
      :campaignId="campaignId"
      @payment-success="onPaymentSuccess"
    />
  </div>
</template>

<script>
import { getCurrentEnvironment } from "@/core/config/hapi/environments";
import BillingWidget from "@/view/components/checkout/BillingWidget";

// importing ApiService and using ApiService.url does not work, it's empty
// probably some lifecycle bug
const environment = getCurrentEnvironment();

export default {
  name: "TopUp",
  components: {
    BillingWidget
  },
  props: {
    wallet: Object
  },
  emits: ["refetch-wallet-needed"],
  data() {
    return {
      displayOptions: {},
      showBillingWidget: false,
      topUpClicked: false,
      balance: 0,
      campaignId: null
    };
  },
  computed: {
    paymentIframeUrl() {
      const params = {
        walletId: this.wallet.id,
        partnerId: environment.partnerId,
        amount: this.amount,
        returnUrl: window.location.href,
        successCallbackUrl: window.location.href
      };

      if (this.$route.query.redirect) {
        params.redirect = this.$route.query.redirect;
      }

      if (this.$route.query.paymentMethodTypes) {
        params.paymentMethodTypes = this.$route.query.paymentMethodTypes;
      }

      const encodedParams = Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
      return `${environment.apiBaseUrl}wallet/topup.html?${encodedParams}`;
    }
  },
  methods: {
    async onTopUpClick() {
      this.showBillingWidget = true;
      this.topUpClicked = true;
      this.$emit("refetch-wallet-needed");
    },
    async onTopUpCancelClick() {
      this.topUpClicked = false;
      this.showBillingWidget = false;
    },
    async onPaymentSuccess() {
      this.$emit("refetch-wallet-needed");
    }
  }
};
</script>
